export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'local'

// UQRDM Urls
export const API_URL = import.meta.env.VITE_API_URL
export const BASE_URL = import.meta.env.VITE_BASE_URL // This application's URL

// Auth
export const UQRDM_SSO_COOKIE_REFRESH_NAME = import.meta.env.VITE_UQRDM_SSO_COOKIE_REFRESH_NAME
export const UQRDM_SSO_LOGIN_URL = import.meta.env.VITE_UQRDM_SSO_LOGIN_URL
export const UQRDM_SSO_UQ_LOGIN_URL = import.meta.env.VITE_UQRDM_SSO_UQ_LOGIN_URL
export const UQRDM_SSO_LOGOUT_URL = import.meta.env.VITE_UQRDM_SSO_LOGOUT_URL
// IdP SSOService entry point + SP entity id, used to deep-link straight to a user's auth provider
export const UQRDM_SSO_SERVICE_URL = import.meta.env.VITE_UQRDM_SSO_SERVICE_URL
export const UQRDM_SSO_SP_ENTITY_ID = import.meta.env.VITE_UQRDM_SSO_SP_ENTITY_ID

// Sentry
export const SENTRY_DSN_WEB = import.meta.env.VITE_SENTRY_DSN_WEB

// ESPACE
export const ESPACE_API_BASE_URI = import.meta.env.VITE_ESPACE_API_BASE_URI
export const ESPACE_WEB_BASE_URL = import.meta.env.VITE_ESPACE_WEB_BASE_URL
export const ESPACE_WEB_AMENDMENT_BASE_URI = import.meta.env.VITE_ESPACE_WEB_AMENDMENT_URL
